import { z } from 'zod';
import { Paginated } from '../../common/pagination.js';
import { AdminActionInput, AuditEntry } from '../shared.js';
import { AdminAccountView, AuditQuery, CreateAdminInput } from './schemas.js';
import { SetAdminRoleInput } from '../roles/schemas.js';
export const adminAdminsRoutes = {
    admins: { method: 'GET', path: '/admin/admins', response: z.array(AdminAccountView) },
    createAdmin: {
        method: 'POST',
        path: '/admin/admins',
        body: CreateAdminInput,
        response: AdminAccountView,
    },
    suspendAdmin: {
        method: 'POST',
        path: '/admin/admins/:adminId/suspend',
        body: AdminActionInput,
        response: AdminAccountView,
    },
    setAdminRole: {
        method: 'PUT',
        path: '/admin/admins/:adminId/role',
        body: SetAdminRoleInput,
        response: AdminAccountView,
    },
    audit: {
        method: 'GET',
        path: '/admin/audit',
        query: AuditQuery,
        response: Paginated(AuditEntry),
    },
};
//# sourceMappingURL=routes.js.map